import React from 'react';
import { ShowWhatYouKnow } from 'abbot-core';
import voAudio from '../../assets/vo/U1-T2-1-3.mp3';
import img from '../../assets/images/U1-T2-1-3a.svg';

const vo = {
  src: voAudio,
  transcript: 'Before we learn more about making the most nutritious food choices possible and how food choices affect your health, let’s see what you already know. Don’t worry. You aren’t expected to have all the answers yet! Just do the best you can.'
};

const paragraphText = 'Let’s see what you already know about nutritious food choices and how food choices affect your health.';

export default {
  title: 'Show What You Know',
  path: '/prepare/show-what-you-know',
  content: (
    <ShowWhatYouKnow
      paragraphText={paragraphText}
      vo={vo}
      image={img}
    />
  )
};



// WEBPACK FOOTER //
// ./src/data/prepare/ShowWhatYouKnow.js